enum ActionTypes {
  LOAD_BACK_OFFICE_ENTERPRISE_SITES_REQUEST = 'LOAD_BACK_OFFICE_ENTERPRISE_SITES_REQUEST',
  LOAD_BACK_OFFICE_ENTERPRISE_SITES_SUCCESS = 'LOAD_BACK_OFFICE_ENTERPRISE_SITES_SUCCESS',
  LOAD_BACK_OFFICE_ENTERPRISE_SITES_FAILURE = 'LOAD_BACK_OFFICE_ENTERPRISE_SITES_FAILURE',

  SET_BACK_OFFICE_ENTERPRISE_SITES = 'SET_BACK_OFFICE_ENTERPRISE_SITES'
}

export default ActionTypes;
